export const ASSET_CLASSES = {
	equity: 'Equity',
	fixedIncome: 'Fixed Income',
	allocation: 'Multi Asset',
	alternative: 'Alternatives',
	other: 'Other'
};

export const ASSET_CLASSES_PAS_MAPPING = {
	Equity: 'equity',
	'Fixed Income': 'fixedIncome',
	Allocation: 'allocation',
	Alternative: 'alternative',
	Other: 'other'
};
